import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getContactsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/users/me/contacts");

  return response.data;
};
